import { useParams } from "react-router-dom";
import { ClientForm } from "@/components/admin/clients/ClientForm";
import { DeleteClientDialog } from "@/components/admin/clients/DeleteClientDialog";

export default function EditClient() {
  const { id } = useParams();

  return (
    <div className="container mx-auto p-6 max-w-xl">
      <h1 className="text-3xl font-bold mb-6">Edit Client</h1>
      <ClientForm />

      {id && (
        <section className="mt-10 rounded-md border border-destructive p-4 space-y-3">
          <h2 className="text-lg font-semibold text-destructive">
            Danger zone
          </h2>
          <p className="text-sm text-muted-foreground">
            Permanently delete this client and every bid under it. Meant for
            spam. Clients with invoices, check batches or signed up staff are
            protected and cannot be deleted.
          </p>
          <DeleteClientDialog clientId={id} />
        </section>
      )}
    </div>
  );
}
